"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discount_1 = require("./discount");
exports.DiscountService = discount_1.DiscountService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/discount/services/index.js
// module id = 398
// module chunks = 0